<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Veicoli </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="dialog_calendario_generico = true" small v-bind="attrs" v-on="on">
            <v-icon color="primary"> mdi-calendar </v-icon>
          </v-btn>
        </template>
        <span>Vedi calendario generico</span>
      </v-tooltip>
      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="creaCalendario" small v-bind="attrs" v-on="on" class="ml-5">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Crea calendario schedulazione</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-autocomplete background-color="#ffffff" @change="filtra()" hide-details :items="lista_macchine"
          item-text="targa" item-value="id_macchina" label="Targa" style="display: inline-block; max-width: 350px"
          v-model="targa_filtro">
          <template v-slot:append>
            <v-icon class="ml-2" @click="
              targa_filtro = '';
            filtra();
            " color="primary">{{
                targa_filtro == "" ? "mdi-filter" : "mdi-filter-off"
              }}</v-icon>
          </template>
        </v-autocomplete>
      </v-col></v-row>

    <v-data-table height="60vh" style="width: 50vw; margin: auto" :headers="headers_macchine" :items="lista_vista"
      :page="page_num" @update:page="pageChange" fixed-header :key="aggiorna" class="elevation-1 pt-0">
      <!-- Colonna del calendario specifico -->
      <template v-slot:[`item.cal_spec`]="{ item }">
        <v-btn @click="clickCalSpecifico(item)" small><v-icon
            :color="item.eccezione ? 'orange' : 'primary'">mdi-calendar-star</v-icon></v-btn>
      </template>
      <!-- Colonna del calendario specifico -->
      <template v-slot:[`item.cal_gen`]="{ item }">
        <v-btn @click="generaCalendario(item)" small><v-icon
            :color="item.disponibilita ? 'primary' : 'orange'">mdi-calendar-plus</v-icon></v-btn>
      </template>
    </v-data-table>
    <!-- DIALOG CALENDARIO GENERICO -->
    <v-dialog v-model="dialog_calendario_generico" max-width="600px">
      <CalendarioGenerico @click_chiudi="
        dialog_calendario_generico = false;
      pageSet();
      " :bottoni="true" />
    </v-dialog>
    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico @click_chiudi="
        dialog_calendario_specifico = false;
      getEccezioniLista();
      pageSet();
      " :id_riferimento="macchina_sel_id" :tipo="3" />
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import CalendarioGenerico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioGenerico.vue";
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",

  components: { CalendarioGenerico, CalendarioSpecifico, SnackbarQV },

  props: ["id_macchina"],

  data() {
    return {
      // Variabili d'appoggio
      macchina_sel_id: null,
      targa_filtro: "",
      aggiorna: 0,
      page_num: 1,
      // Modal
      dialog_calendario_generico: false,
      dialog_calendario_specifico: false,

      // Array
      headers_macchine: new Array(),
      lista_macchine: new Array(),
      lista_vista: new Array(),
      lista_eccezioni: new Array(),
      lista_disponibilita: new Array(),

      //Array per la creazione del calendario dello schedulatore
      persone: new Array(),
    };
  },

  computed: {},

  watch: {
    lista_macchine: {
      immediate: true,
      handler() {
        this.lista_vista = this.lista_macchine;
        this.filtra();
      },
    },
  },

  methods: {
    clickCalSpecifico(arg) {
      this.dialog_calendario_specifico = true;
      this.macchina_sel_id = arg.id_macchina;
      console.log(this.macchina_sel_id, arg);
      let obj = {
        id_persona: this.macchina_sel_id,
      }
      console.log("pusho", obj);
      this.persone.push(obj);
    },
    generaCalendario(item) {
      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "salvacalendariomacchine",
          token: localStorage.getItem("user_token"),
          macchine: [{ id_macchina: item.id_macchina }],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getMacchine();
            this.$refs.SnackbarQV.print("success", "Salvataggio Effettuato.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    creaCalendario() {
      // this.persone = this.persone.toString();

      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "salvacalendariopersone",
          token: localStorage.getItem("user_token"),
          persone: this.persone,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.persone = [];
            this.macchina_sel_id = null;
            this.$refs.SnackbarQV.print("success", "Salvataggio Effettuato.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    filtra() {
      if (this.lista_macchine.length == 0) {
        return;
      }
      let veicoli = [];
      this.lista_macchine.forEach((elem) => {
        veicoli.push(elem);
      });

      // Filtro la targa
      if (this.targa_filtro != "" && this.targa_filtro != null) {
        let res = [];

        veicoli.forEach((elem) => {
          if (elem.id_macchina == this.targa_filtro) {
            res.push(elem);
          }
        });

        veicoli = res;
      }

      this.lista_vista = [];
      this.lista_vista = Array.from(veicoli);
    },

    getMacchine() {
      this.headers_macchine = [
        {
          text: "Calendario specifico",
          value: "cal_spec",
        },
        // {
        //   text: "Genera calendario",
        //   value: "cal_gen",
        // },
        {
          text: "Targa",
          value: "targa",
        },
        {
          text: "Codice interno",
          value: "codice_interno",
        },
      ];

      let request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
          id_tipo_macchina: 33570,
          // idmacchina:this.id_macchina
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_macchine = [];
            res.data.macchine
              .filter((a) => a.extra.length > 0 && a.extra[0].validita == 1)
              .forEach((v) => {
                this.lista_macchine.push(v.extra[0]);
              });
            this.getEccezioniLista();
            this.getDisponibilitaLista();
            this.pageSet();
            //console.table(this.lista_macchine);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    getEccezioniLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "geteccezionilista",
          token: localStorage.getItem("user_token"),
          tipo: 3,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_eccezioni = res.data.calendario_ecc
            ? res.data.calendario_ecc
            : [];
          this.lista_macchine.forEach((v) => {
            v.eccezione = false;
            this.lista_eccezioni.forEach((ecc) => {
              if (v.id_macchina == ecc.rif_calendario) {
                v.eccezione = true;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },

    getDisponibilitaLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getdisponibilitamacchina",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_disponibilita = res.data ? res.data : [];
          this.lista_macchine.forEach((v) => {
            v.disponibilita = true;
            this.lista_disponibilita.forEach((ecc) => {
              if (v.id_macchina == ecc.id_macchina) {
                v.disponibilita = false;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },

    pageChange(page) {
      sessionStorage.setItem("page_veicolical", page);
    },

    pageSet() {
      if (sessionStorage.getItem("page_veicolical"))
        this.page_num = parseInt(sessionStorage.getItem("page_veicolical"));
    },
  },

  created() { },

  async mounted() {
    await this.pageChange(1);
    await this.getMacchine();
    if (this.id_macchina) {
      this.targa_filtro = this.id_macchina;
      this.filtra();
    }
  },
};
</script>

<style scoped></style>